export default __webpack_public_path__ + "static/media/one.a97544f5.jfif";